export default "__VITE_ASSET__BjazRDnB__"